import { AccessTypeTag } from './AccessTypeTag';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SanitizedHtml } from '@ui/general';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import { ObjectPermissionsTag, permissionLabel } from './ObjectPermissionsTag';
export const accessNameColumn = {
    dataIndex: 'accessName',
    fixed: 'left',
    key: 'accessName',
    title: COPY_SPECIFIC.ACCESS_NAME,
    width: 400
};
export const accessTypeColumn = {
    dataIndex: 'accessType',
    fixed: 'left',
    key: 'accessType',
    render: (accessType) => React.createElement(AccessTypeTag, { accessType: accessType }),
    title: COPY_SPECIFIC.ACCESS_TYPE,
    width: 160
};
export const permissionsColumn = {
    dataIndex: 'permissions',
    fixed: 'left',
    key: 'permissions',
    render: (permissions) => React.createElement(ObjectPermissionsTag, { permissions: permissions }),
    title: COPY_SPECIFIC.PERMISSIONS,
    width: 160
};
export const permissionSourceColumn = {
    dataIndex: 'permissions',
    key: 'permissionSource',
    render: (permissions) => React.createElement("div", null, Object.entries(permissions).reduce((acc, [key, value]) => (value ?
        React.createElement(React.Fragment, null,
            React.createElement(When, { condition: Boolean(acc) },
                acc,
                React.createElement(SanitizedHtml, { as: 'span', html: ', ' })),
            React.createElement(SonarText, { weight: 'semibold' },
                permissionLabel[key],
                React.createElement(SanitizedHtml, { as: 'span', html: ': ' })),
            React.createElement(SonarText, null, value)) :
        acc), null)),
    title: COPY_SPECIFIC.PERMISSION_SOURCE
};
export function getColumns() {
    return [
        accessNameColumn,
        accessTypeColumn,
        permissionsColumn,
        permissionSourceColumn
    ];
}
